"use client";

import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

/**
 * The full-screen result list on mobile.
 *
 * Kept mounted and hidden rather than unmounted when the user switches back to the
 * map: the list holds scroll position and in-flight queries, and remounting it on
 * every toggle would refetch and jump back to the top.
 *
 * Inset top and bottom so it sits between the header and the view toggle instead
 * of underneath them.
 */
export function MobileListView({
  visible,
  children,
}: {
  visible: boolean;
  children?: ReactNode;
}) {
  return (
    <div
      // Hidden from assistive tech too — off-screen but mounted is still
      // reachable to a screen reader otherwise.
      aria-hidden={!visible}
      inert={!visible}
      className={cn(
        "fixed inset-x-0 z-30 flex flex-col bg-white dark:bg-dark-color",
        "top-14 bottom-14 transition-opacity duration-300 ease-out",
        visible ? "visible opacity-100" : "pointer-events-none invisible opacity-0"
      )}
    >
      <div className="flex-auto overflow-y-auto">{children}</div>
    </div>
  );
}
